import React, { Component } from 'react';

class HomePageLoader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      component: null
    };
  }

  componentDidMount() {
    return import(/* webpackChunkName: "zen/HomePage.zen" */ './HomePage')
      .then((HomePage) => {
        this.setState({component: HomePage.default});
      }).catch(
      // eslint-disable-next-line no-console
        (error) => console.error('An error occurred while loading \'HomePage\'',error)
      );
  }

  render () {
    return (
      <span>{this.state.component && (<this.state.component {...this.props} />)}</span>
    );
  }
}

export default HomePageLoader;
